import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {EmployeeDetailsReportModel} from "./employee-details-report.model";
import {AbstractReportPage} from "../../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-employee-details-report-page",
    templateUrl: "./employee-details-report-page.component.html",
    providers: [provideReportModel(EmployeeDetailsReportModel)]
})
export class EmployeeDetailsReportPageComponent extends AbstractReportPage {

    constructor(public model: EmployeeDetailsReportModel) {
        super();
    }
}
